import { Action } from '@ngrx/store';
import { VitrineOfferInterface } from '../../models/vitrine-offer.interface';

export enum EChangeOffersEligibleListActions {
  GetChangeOffersEligibleList = '[CHANGE_OFFERS_ELIGIBLE_LIST] Get change offers eligible list',
  GetChangeOffersEligibleListSuccess = '[CHANGE_OFFERS_ELIGIBLE_LIST] Get change offers eligible list success',
  GetChangeOffersEligibleListFailure = '[CHANGE_OFFERS_ELIGIBLE_LIST] Get change offers eligible list failure',
}

export class GetChangeOffersEligibleList implements Action {
  public readonly type = EChangeOffersEligibleListActions.GetChangeOffersEligibleList;
  constructor(public offerId: number, public phoneNumber: string) {}
}

export class GetChangeOffersEligibleListSuccess implements Action {
  public readonly type = EChangeOffersEligibleListActions.GetChangeOffersEligibleListSuccess;
  constructor(public payload: Array<VitrineOfferInterface>) {}
}

export class GetChangeOffersEligibleListFailure implements Action {
  public readonly type = EChangeOffersEligibleListActions.GetChangeOffersEligibleListFailure;
}

export type ChangeOffersEligibleListActions = GetChangeOffersEligibleList | GetChangeOffersEligibleListSuccess | GetChangeOffersEligibleListFailure;
